import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { generalService } from '../../services/general.service';
import { Cliente } from '../../models/cliente';

@Component({
  selector: 'my-cliente-detalle',
  styleUrls: [], 
  templateUrl: 'cliente-detalle.component.html',
  providers: [generalService]
})
export class ClienteDetalleComponent implements OnInit {
 @Input() cliente: Cliente;
formCliente: FormGroup;
titulo = "";
isUpdate: boolean;
cliente_id: string;
list: any;
reader: FileReader;
	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		private route: ActivatedRoute,
		private _generalService: generalService
		) {
		this.list = new Object();
		this.cliente = new Cliente();
		this.formCliente = new FormGroup({});
		this.cliente_id = this.route.snapshot.paramMap.get('id');
		//Usar en caso de emergencia con el router
		// this.router.events.subscribe(path => {
		//   console.log('path = ', path);
		// });

	}

	ngOnInit() {
		this.buildForm();
		this.initNewOrUpdate();		
    this.route.params.subscribe(params => {
      if(this.cliente_id != params['id']){
          this.cliente_id = params['id'];
          this.initNewOrUpdate();// reset and get based on new :id
      }
    });
		
  	}

  	getCliente(id:any){
	    this._generalService.metodoCall(`cliente/consultarCliente/${id}`).subscribe(
	        result => {
        		let res = JSON.parse(result);
	        	if(res.some(e => true)){
	        		this.cliente = res[0];
              this.titulo = "Actualizar Cliente"
              this.isUpdate = true;
	        		//this.personal.DATE_OF_BIRTH = new Date(this.personal.DATE_OF_BIRTH);
	        	}
	        	else
    				this.router.navigate(['../', 'N'], {relativeTo: this.route });
          	},
	        error => {
	          console.log(<any>error);
	        }
      	);
  	}


  	updateCliente(){
		console.log(this.cliente);
  		this._generalService.metodoCallParams(this.cliente, "cliente/actualizarCliente").subscribe(
          result => {
          	this._generalService.toastCall(result.message);
           
          },
          error => {
            console.log(<any>error);
          }
      ); 
  	}

  	createCliente(){
		this.cliente.loacs = sessionStorage.getItem("acslo");
  		this._generalService.metodoCallParams(this.cliente, "cliente/agregarCliente").subscribe(
          result => {
          	this._generalService.toastCall(result.message);
			 
       this.router.navigate(['../', result.data], {relativeTo: this.route });
          },
          error => {
            console.log(<any>error);
          }
      ); 
  	}

  	onSubmit() {      
  	  if(this.isUpdate)
  	  	this.updateCliente();
  	  else
  	  	this.createCliente();
      
  	}

    back(){
       this.router.navigate(['../'],{ relativeTo: this.route });
    }

  	initNewOrUpdate(){
  			
		if(this.cliente_id == 'N'){
			this.titulo = "Nuevo Cliente"
			this.isUpdate = false;
			this.cliente = new Cliente();
		}
		else
    		this.getCliente(this.cliente_id);  		
  	}

  

  	buildForm() {
    	this.formCliente = this.formBuilder.group({
	      Nombre: this.formBuilder.control(null,[Validators.required, Validators.maxLength(101)]),
	      Numero: this.formBuilder.control(null, [Validators.required, Validators.maxLength(20)]),
	      RFC: this.formBuilder.control(null, [Validators.required, Validators.maxLength(20)]),
	      Email: this.formBuilder.control(null, [Validators.required, Validators.maxLength(101)]),
	      Salario: this.formBuilder.control(null, [Validators.required, Validators.maxLength(101)]),
    	});
    }
}


// WEBPACK FOOTER //
// ./src/app/cliente/agregar-editar/cliente-detalle.component.ts